import { RootState } from 'types';

export const selectShowToast = (state: RootState) =>
  state?.errorHandling?.showToast;
